import { Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  position: 'absolute',
  left: '0px',
  top: '0px',
  display: 'flex',
  flexDirection: 'row',
  width: '1920px',
  height: '1080px',
  zIndex: 10
});

export const mainContainer = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '120px',
  padding: '64px',
  width: '1280px',
  height: '952px',
  backgroundColor: 'rgba(0, 0, 0, .6)'
});

export const mainContentContainer = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '120px',
  paddingLeft: '80px'
});

export const profileImageContainer = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '300px',
  height: '400px',
  borderRadius: '8px',
  overflow: 'hidden'
});

export const image = css({
  display: 'none',
  width: '100%',
  height: '100%',
  objectFit: 'cover'
});

export const imageLoaded = css({
  display: 'initial'
});

export const defaultImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover'
});

export const profileContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '80px'
});

export const profileMainContainer = css({});

export const profileDescriptionContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '48px'
});

export const profileDescription = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px'
});

export const name = css({
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700
});

export const descriptionTitle = css({
  color: White.White10Alpha70,
  fontSize: '24px',
  fontWeight: 500
});

export const descriptionContentContainer = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '16px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: White.White10,
  fontSize: '28px',
  fontWeight: 700
});

export const rightContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  rowGap: '20px',
  padding: '64px',
  width: '512px',
  height: '952px',
  backgroundColor: Gray.Gray90
});

export const informationContainer = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  columnGap: '8px'
});

export const information = css({
  color: Gray.Gray60,
  fontSize: '20px',
  fontWeight: 500
});
